module.exports = __webpack_public_path__ + "static/img/duihao-choose.3c27868.jpg";